import {render} from 'preact';
import {useEffect, useMemo, useState} from 'preact/hooks';
import {ErrorBoundary, LocationProvider, Route, Router} from 'preact-iso';

import {LanguageContext} from '../../extensions/add-ons-admin/src/lib/i18n.js';
import AppearancePage from '../../extensions/add-ons-admin/src/pages/AppearancePage.jsx';
import GroupPage from '../../extensions/add-ons-admin/src/pages/GroupPage.jsx';
import GroupsPage from '../../extensions/add-ons-admin/src/pages/GroupsPage.jsx';
import NotFoundPage from '../../extensions/add-ons-admin/src/pages/NotFoundPage.jsx';
import {installDevShopifyMock} from './dev-shopify.js';
import './styles.css';

const LANGUAGE_KEY = 'impact_addons_language';

window.__IMPACT_ADDONS_IFRAME__ = true;
if (import.meta.env.DEV && !window.shopify) installDevShopifyMock();

function readLanguage() {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_KEY);
    return stored === 'en' ? 'en' : 'zh';
  } catch {
    return 'zh';
  }
}

function saveLanguage(language) {
  try {
    window.localStorage.setItem(LANGUAGE_KEY, language);
  } catch {
    // The language preference is optional; Shopify data is unaffected.
  }
}

function App() {
  const [language, setLanguage] = useState(readLanguage);

  useEffect(() => {
    document.documentElement.lang = language === 'zh' ? 'zh-CN' : 'en';
  }, [language]);

  const context = useMemo(() => ({
    language,
    setLanguage: (next) => {
      setLanguage(next);
      saveLanguage(next);
    },
    toggleLanguage: () => {
      const next = language === 'zh' ? 'en' : 'zh';
      setLanguage(next);
      saveLanguage(next);
    },
  }), [language]);

  return (
    <LanguageContext.Provider value={context}>
      <LocationProvider>
        <s-app-nav>
          <s-link href="/">{language === 'zh' ? '配件组' : 'Add-on groups'}</s-link>
          <s-link href="/appearance">{language === 'zh' ? '全局样式' : 'Global appearance'}</s-link>
        </s-app-nav>
        <ErrorBoundary>
          <Router>
            <Route path="/" component={GroupsPage} />
            <Route path="/groups/:id" component={GroupPage} />
            <Route path="/appearance" component={AppearancePage} />
            <Route default component={NotFoundPage} />
          </Router>
        </ErrorBoundary>
      </LocationProvider>
    </LanguageContext.Provider>
  );
}

render(<App />, document.getElementById('app'));
